var replacements = {

	/**
	 * Between replacement (replaces :min and :max)
	 *
	 * @param  {string} template
	 * @param  {Rule} rule
	 * @return {string}
	 */
	between: function(template, rule) {
		var parameters = rule.getParameters();
		return this._replacePlaceholders(rule, template, { min: parameters[0], max: parameters[1] });
	},

	/**
	 * Required_if replacement.
	 *
	 * @param  {string} template
	 * @param  {Rule} rule
	 * @return {string}
	 */
	required_if: function(template, rule) {
		var parameters = rule.getParameters();
		return this._replacePlaceholders(rule, template, { other: parameters[0], value: parameters[1] });
	}
};

function formatter(attribute)
{
	return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
}

module.exports = {
	replacements: replacements,
	formatter: formatter
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/validatorjs/src/attributes.js
 ** module id = 81
 ** module chunks = 0
 **/